export default __webpack_public_path__ + "static/media/full-digital-report.c70f1be4.png";